export const ROUTES = {
  root: '/',
  search: '/search',
  freeResources: '/free-resources',
  ucasCoaching: '/ucas-coaching',
  blog: '/blog',
  about: '/about',
  tutorProfile: `/tutor/profile/[slug]`,
  login: '/auth/login',
  signup: '/auth/signup',
  // Login is unified/role-agnostic. Signup has dedicated routes per role:
  // /auth/signup (chooser), /auth/signup/student, /auth/signup/tutor.
  studentLogin: '/auth/login',
  studentSignup: '/auth/signup/student',
  tutorLogin: '/auth/login',
  tutorSignup: '/auth/signup/tutor',
  thankYou: '/thank-you',
};
